// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AgrQ7","colMin":"styles_colMin__1lo7n"};